import * as React from 'react';

import classnames from 'classnames';

import {PopoverInfo} from '../popover-info/popover-info';

import styles from './label.module.css';

type Props = {
    htmlFor: string;
    tooltipInfo?: string | React.ReactNode;
    shouldTooltipFadeIn?: boolean;
    required?: boolean;
    isTwoLines?: boolean;
    children?: React.ReactNode;
    inline?: boolean;
    noBottomMargin?: boolean; // Label without the 8px bottom margin,
    largeSize?: boolean; // Font size is 16px for certain forms where other labels are standard 15px
};

export function Label(props: Props) {
    const styleNames = classnames({
        [styles['label']]: true,
        [styles['label--inline']]: props.inline,
        [styles['label--required']]: props.required,
        [styles['label--inline-block']]: props.isTwoLines,
        [styles['label--no-bottom-margin']]: props.noBottomMargin,
        [styles['label--large-size']]: props.largeSize,
    });

    return (
        <label htmlFor={props.htmlFor} className={styleNames}>
            {props.children}
            {props.tooltipInfo ? (
                <div style={{height: 0, marginTop: '-1px'}}>
                    <PopoverInfo
                        size={18}
                        info={props.tooltipInfo}
                        shouldFadeIn={props.shouldTooltipFadeIn}
                    />
                </div>
            ) : undefined}
        </label>
    );
}
